<template>
    <div class="documents">
        <div class="toolbar toolbar-tabs" v-if="tabs.length">
            <div class="toolbar-content">
                <!--                <div class="left"><button class="document-list-button">Document List <i class="gf gf-sort-down"></i></button></div>-->
                <div class="right">
                    <document-tabs :active-tab-id="activeTabId" :tabs="tabs" @clickTabWithId="clickTabWithId"
                                   @closeTabWithId="onClickCloseButton"></document-tabs>
                </div>
            </div>
        </div>
        <document-tab-content v-for="tab in tabs"
                              :key="tab.tabId"
                              :global-document-id="tab.tabId"
                              :project-id="projectId"
                              v-show="activeTabId === tab.tabId"
                              @documentLoaded="documentLoaded"
                              @documentFetchingError="documentFetchingError"
                              @documentStartLoading="documentStartLoading"
                              ref="documentTabContent"></document-tab-content>
        <div class="global-message-box" v-if="!tabs.length">
            <div class="text-center">
                <div class="mb-1">No open documents.</div>
                <div>Go to Overview and open a document to review.</div>
            </div>
        </div>
    </div>
</template>
<script>
    import DocumentTabContent from "@/components/DocumentTabContent";
    import DocumentTabs from "@/components/DocumentTabs";
    import {Promise} from 'es6-promise-polyfill'
    import {deepCompare} from "@/utils";
    import {closeDocument} from "@/apis";
    import projectIdToTemplate from "@/config/projectIdToTemplate";

    export default {
        name: 'documents',
        components: {DocumentTabs, DocumentTabContent},
        props: {
            projectId: String,
        },
        methods: {
            setActiveTabId(tabId, hle, hlf, hls) {
                const query = {d: tabId, hle, hlf, hls};

                if (this.activeTabId === tabId && deepCompare(query, this.$route.query)) {
                    return
                }

                if (this.enableSerial) {
                    if (this.activeTabId !== tabId) {
                        const tab = this.findTab(tabId);

                        if (tab && tab.loaded) {
                            const target = this.getDocumentTabContentComponentByTabId(tab.tabId);
                            target.updateSerialManagerAndCards();
                        }
                    }
                }

                this.$router.push({name: 'documents', query, params: {pid: this.projectId}})
            },
            findTab(tabId) {
                for (let i = 0; i < this.tabs.length; i++) {
                    if (this.tabs[i].tabId === tabId) {
                        return this.tabs[i];
                    }
                }
                return null;
            },
            openNewDocument(globalDocumentId) {
                this.tabs.push({
                    tabId: globalDocumentId,
                    tabLabel: 'Loading Document...',
                    loaded: false,
                    editToken: null,
                })
            },
            documentLoaded(globalDocumentId, detail) {
                const tab = this.findTab(globalDocumentId);
                if (tab) {
                    tab.tabLabel = detail.documentId;
                    tab.loaded = true;
                    tab.editToken = detail.currentlyEditedToken;
                    this.checkToJumpToAnywhere();
                }
            },
            documentFetchingError(globalDocumentId) {
                const tab = this.findTab(globalDocumentId);
                if (tab) {
                    tab.tabLabel = "Cannot Load Document";
                }
            },
            documentStartLoading(globalDocumentId) {
                const tab = this.findTab(globalDocumentId);
                if (tab) {
                    tab.tabLabel = 'Loading Document...';
                    tab.loaded = false;
                }
            },
            checkToJumpToAnywhere() {
                const tab = this.findTab(this.activeTabId);
                if (tab && tab.loaded) {
                    const query = this.$route.query;
                    if (typeof query.hle !== 'undefined') {
                        this.getDocumentTabContentComponentByTabId(tab.tabId).highlightEventAndProperty(query.hle, query.hlf);
                    } else if (typeof query.hls !== 'undefined') {
                        this.getDocumentTabContentComponentByTabId(tab.tabId).highlightSerial(query.hls);
                    }
                }
            },
            clickTabWithId(tabId) {
                this.setActiveTabId(tabId)
            },
            getDocumentTabContentComponentByTabId(tabId) {
                return this.$refs.documentTabContent && this.$refs.documentTabContent.filter(item => (item.globalDocumentId === tabId))[0] || null;
            },
            onClickCloseButton(tabId) {
                this.closeTabWithId(tabId);
            },
            closeTabWithId(tabId, confirm) {
                if (typeof confirm === 'undefined') {
                    confirm = true;
                }

                if (confirm && !this.getDocumentTabContentComponentByTabId(tabId).checkCloseable() && !window.confirm('There are unsaved changes. Are you sure you want to close the current document?')) {
                    // not closed
                    return Promise.reject();
                }

                const tabToClose = this.findTab(tabId);

                return closeDocument(tabId, tabToClose.editToken).then(() => {
                    this.vCloseTabWithId(tabId);
                }).catch(err => {
                    return this.handleServerSideError(err).then(() => {
                        return Promise.reject();
                    }).catch(() => {
                        if (tabToClose.loaded) {
                            if (window.confirm('There is something not right while closing the document. Close anyway?')) {
                                // closed successfully
                                this.vCloseTabWithId(tabId);
                                return Promise.resolve()
                            } else {
                                // closed successfully
                                return Promise.reject()
                            }
                        } else {
                            // closed successfully
                            this.vCloseTabWithId(tabId);
                            return Promise.resolve()
                        }
                    })
                })
            },
            vCloseTabWithId(tabId) {
                let closedTabIndex = -1;

                const newTabs = [];
                this.tabs.forEach((tab, index) => {
                    if (tab.tabId === tabId) {
                        closedTabIndex = index;
                    } else {
                        newTabs.push(tab);
                    }
                });

                if (this.activeTabId === tabId) {
                    let nextActiveTabIndex = -1;
                    if (closedTabIndex < newTabs.length) {
                        nextActiveTabIndex = closedTabIndex;
                    } else if (closedTabIndex - 1 < newTabs.length) {
                        nextActiveTabIndex = closedTabIndex - 1;
                    }
                    if (nextActiveTabIndex >= 0) {
                        this.setActiveTabId(newTabs[nextActiveTabIndex].tabId);
                    } else {
                        this.$router.push({name: 'documents', params: {pid: this.projectId}})
                    }
                }
                this.tabs = newTabs;
            },
            closeAllTabs(confirm) {
                const tabIds = this.tabs.map((tab) => tab.tabId);
                const _this = this;
                let promise = Promise.resolve();
                for (let i = 0; i < tabIds.length; i++) {
                    (function (tabId) {
                        promise = promise.then(() => {
                            return new Promise((resolve, reject) => {
                                _this.setActiveTabId(tabId);
                                _this.$nextTick(() => {
                                    setTimeout(() => {
                                        _this.closeTabWithId(tabId, confirm).then(() => {
                                            _this.$nextTick(() => {
                                                window.setTimeout(() => {
                                                    resolve()
                                                }, 0)
                                            })
                                        }).catch(() => {
                                            reject()
                                        })
                                    }, 0);
                                })
                            })
                        })
                    })(tabIds[i])
                }
                return promise;
            },
            closeAllTabsSwiftly() {
                for (let i = 0; i < this.tabs.length; i++) {
                    const tab = this.tabs[i];
                    closeDocument(tab.tabId, tab.editToken);
                }
            },
            makeDocumentOpen(globalDocumentId, silent, focusEventId, focusFieldId, focusSerialId) {
                if (silent) {
                    if (!this.findTab(globalDocumentId)) {
                        this.openNewDocument(globalDocumentId);
                    }
                } else {
                    this.setActiveTabId(globalDocumentId, focusEventId, focusFieldId, focusSerialId);
                    this.$nextTick(() => {
                        this.checkToJumpToAnywhere();
                    });
                }
            }
        },
        data() {
            return {
                tabs: [],
                lastActiveTabId: null,
                openDocumentListener: null,
            }
        },
        watch: {
            $route: {
                handler(to) {
                    if (to.params.pid !== this.projectId) {
                        return;
                    }
                    if (to.name === 'documents' && !to.query.d && this.tabs.length) {
                        this.setActiveTabId(this.lastActiveTabId || this.tabs[0].tabId);
                    }
                },
                immediate: true
            },
            activeTabId: {
                handler(to) {
                    if (this.$route.params.pid !== this.projectId) {
                        return;
                    }
                    if (this.$route.name === 'documents') {
                        this.lastActiveTabId = to;
                        if (to && !this.findTab(to)) {
                            this.openNewDocument(to);
                        }
                    }
                },
                immediate: true
            },
            tabs: {
                handler(newVal) {
                    this.$store.commit('setOpenGlobalDocumentIds', {
                        projectId: this.projectId,
                        globalDocumentIds: newVal.map(item => (item.tabId)),
                    })
                },
                immediate: true
            }
        },
        created() {
            this.openDocumentListener = (payload) => {
                const {globalDocumentId, silent, focusEventId, focusFieldId, focusSerialId, projectId} = payload;

                if (projectId !== this.projectId) {
                    return;
                }

                this.makeDocumentOpen(globalDocumentId, silent, focusEventId, focusFieldId, focusSerialId)
            };
            this.eventHub.$on('openDocument', this.openDocumentListener);
        },
        destroyed() {
            this.eventHub.$off('openDocument', this.openDocumentListener);
        },
        computed: {
            activeTabId() {
                return this.$route.query.d;
            },
            enableSerial() {
                const projectTemplate = projectIdToTemplate[this.projectId];
                return projectTemplate && projectTemplate['enable_serial'];
            },
        }
    }
</script>


<style lang="scss">
    @import "../assets/variables";

    .documents {
        height: 100%;

        .toolbar {
            position: relative;

            .toolbar-content {
                display: flex;
                align-items: center;
            }

            &.toolbar-tabs {
                height: 36px;
                display: flex;
                align-items: flex-end;
                padding: 0 0.5rem;
                z-index: 22;

                .toolbar-content {
                    width: 100%;

                    .right {
                        /*width: calc(100% - 132px);*/
                        width: 100%;
                        padding: 0 0.5rem;
                    }
                }
            }
        }

        .results-indicator {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: gray;
        }
    }
</style>
